/**
 * @generated SignedSource<<214fb1a9df4c03bd40f7a1197e5dfb38>>
 * @relayHash 427b91af5539a42807aedc698e06b0b0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4036680aedddf3d43be10fb7f19ed27fa860e3e3584ff02d8f8163fc2ccbc766

import type { ConcreteRequest } from 'relay-runtime';
export type EditorDraftSyncInput = {
  contentId: string;
  doSetRelations?: boolean | null | undefined;
  latestAdf?: string | null | undefined;
  ncsStepVersion?: number | null | undefined;
};
export type useEditorDraftSyncActionEditorDraftSyncActionMutation$variables = {
  input: EditorDraftSyncInput;
};
export type useEditorDraftSyncActionEditorDraftSyncActionMutation$data = {
  readonly editorDraftSyncAction: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useEditorDraftSyncActionEditorDraftSyncActionMutation = {
  response: useEditorDraftSyncActionEditorDraftSyncActionMutation$data;
  variables: useEditorDraftSyncActionEditorDraftSyncActionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useEditorDraftSyncActionEditorDraftSyncActionMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "EditorDraftSyncPayload",
        "kind": "LinkedField",
        "name": "editorDraftSyncAction",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useEditorDraftSyncActionEditorDraftSyncActionMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "EditorDraftSyncPayload",
        "kind": "LinkedField",
        "name": "editorDraftSyncAction",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "427b91af5539a42807aedc698e06b0b0",
    "id": "4036680aedddf3d43be10fb7f19ed27fa860e3e3584ff02d8f8163fc2ccbc766",
    "metadata": {},
    "name": "useEditorDraftSyncActionEditorDraftSyncActionMutation",
    "operationKind": "mutation",
    "text": "mutation useEditorDraftSyncActionEditorDraftSyncActionMutation($input:EditorDraftSyncInput!){editorDraftSyncAction(input:$input){success,errors{message,extensions{__typename,errorType,statusCode,...on BulkMutationErrorExtension{id}}}}}"
  }
};
})();

(node as any).hash = "714c0f41fd977a5eb40bd778315e24d8";

export default node;
